module.exports = __webpack_public_path__ + "img/pic-2.f5d319a5.png";